module.exports = "<div class=\"swagger-container\"></div>\n"


//////////////////
// WEBPACK FOOTER
// /Users/morne/Documents/dev/remindworks-docs/src/app/swagger/swagger.component.html
// module id = ../../../../../src/app/swagger/swagger.component.html
// module chunks = main